import useStyles from '@app/App.style';
import CONFIG from '@config';
import useRouter from '@hooks/useRouter';
import routes from '@routes';
import React, { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import LazyLoad from 'vanilla-lazyload';

import AppPage from './AppPage';

const App: React.FC = () => {
  const { classes } = useStyles();
  const router = useRouter();

  const lazyload = new LazyLoad({
    elements_selector: '[data-bg], [data-src], [data-bg-multi]'
  });

  useEffect(() => {
    lazyload?.update();
  }, [router.location.pathname]);

  return (
    <div className="fade-in">
      <Routes>
        {Object.keys(routes).map((route) => {
          return (
            <Route
              key={route}
              path={routes[route].path}
              element={<AppPage route={routes[route]}/>}
            />
          );
        })}
      </Routes>

      {['stage', 'development'].indexOf(CONFIG.environment) > -1 ? (
        <div className={classes.appEnvironmentNotice}>
          You are currently viewing the
          {' '}
          <strong>
            {CONFIG.environment}
          </strong>
          {' '}
          site
        </div>
      ) : null}
    </div>
  );
};

export default App;
